/**
 * Gera um UUID v4 (RFC 4122).
 *
 * Tenta na ordem:
 *  1. `crypto.randomUUID()` nativo — só disponível em contextos seguros (HTTPS / localhost).
 *  2. `crypto.getRandomValues()` — CSPRNG disponível também em contextos não-seguros (HTTP + IP).
 *  3. `Math.random()` — fallback último para browsers muito antigos sem Web Crypto.
 *
 * Motivo: em Q.A acessado via `http://<ip>:8081` (não-secure context), `crypto.randomUUID()`
 * lança `TypeError`. Esta função preserva o mesmo formato/contrato e funciona em todos os contextos.
 */
export function safeRandomUUID () {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    crypto.getRandomValues(bytes)
    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
